import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CircularProgress from "@mui/material/CircularProgress";
import React from "react";

export const CardLoading = () => {
  return (
    <Card elevation={1} square={false}>
      <Box p={2} display="flex" flex={1} justifyContent="center" alignItems="center">
        <CircularProgress />
      </Box>
    </Card>
  );
};
